import { UpdateFreespinsBetbarCommand } from "slotworks/commands/betbar/update-freespins-betbar-command";
import { BetBarType } from "slotworks/components/betbar/bet-bar-component";
import Components from "slotworks/components/components";

export function SetFreespinsBetbarCommand() {
    Components.betBar.setType(BetBarType.FREESPINS);

    UpdateFreespinsBetbarCommand();
}
